import React, { useEffect, useState } from "react";
import styled from "styled-components";
import OriginalReleaseDate from "./components/original-release-date";
import ProposedReleaseDate from "./components/proposed-release-date";

import ReleaseTime from "./components/release-time";
import Preorder from "./components/preorder";
import TrackPrice from "./components/track-price";
import Country from "./components/country";

import { ISchedule } from "types/musicData";

export interface ICountry {
  continent: string;
  country: string;
}

interface IProps {
  data: ISchedule;
  setData: (data: ISchedule) => void;
}
const StepFour = ({ data, setData }: IProps) => {
  return (
    <Container>
      <OriginalReleaseDate
        releaseDate={data.originalReleaseDate}
        setReleaseDate={(date) => {
          setData({ ...data, originalReleaseDate: date as Date });
        }}
      />
      <ProposedReleaseDate
        releaseDate={data.proposedReleaseDate}
        setReleaseDate={(date) => {
          setData({ ...data, proposedReleaseDate: date as Date });
        }}
      />
      <ReleaseTime
        time={data.releaseTime}
        setReleaseTime={(time) => setData({ ...data, releaseTime: time })}
      />
      <Preorder
        preorderDate={data.preorderDate}
        setPreorderDate={(date) => {
          setData({ ...data, preorderDate: date as Date });
        }}
      />
      <TrackPrice
        Price={data.trackPrice}
        SetPrice={(price) => {
          setData({ ...data, trackPrice: price });
        }}
      />
      <Country
        countries={data.countries}
        setCountries={(countries) => {
          setData({ ...data, countries });
        }}
      />
    </Container>
  );
};

export default StepFour;

const Container = styled.div`
  width: 100%;
  position: relative;
  justify-content: center;
  height: 100%;
`;
